import { useEffect, useRef } from 'react'
import { useTheme } from 'src/components/contexts/ThemeContext'
import axios from 'axios'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide'
import type { Options } from '@splidejs/splide'

import ProductCard from '../product/ProductCardV2'

import '@splidejs/react-splide/css'
import '@splidejs/react-splide/css/core'
import './shelf-generic.scss'

type ShelfGenericProps = {
  item: any | string
  breakpoints?: Options['breakpoints']
}

function ShelfGenericComponent({
  item,
  breakpoints = {
    240: {
      perPage: 1,
    },
    320: {
      perPage: 1,
    },
    800: {
      perPage: 2,
      fixedHeight: 485,
    },
    1024: {
      perPage: 3,
    },
  },
}: ShelfGenericProps) {
  const observer = useRef<HTMLPreElement>(null)
  const { theme, themes } = useTheme()

  const { shelfs } = themes.filter((idx) => idx.key === theme)[0].styles

  const options: Options = {
    type: 'slide',
    perPage: 4,
    perMove: 1,
    focus: 0,
    omitEnd: true,
    pagination: true,
    gap: '10px',
    breakpoints,
    fixedHeight: 475,
    classes: {
      arrows: 'splide__arrows self-linx-splide',
    },
  }

  useEffect(() => {
    if (observer.current) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          axios.get(item.impressionUrl)
        }
      })

      intersectionObserver.observe(observer?.current)

      return () => intersectionObserver.disconnect()
    }

    return () => {}
  }, [item.impressionUrl])

  return (
    <>
      <pre ref={observer} />
      <h2
        className={`pl-4 text-[32px] !text-neutral10 font-[600] uppercase italic ${shelfs.heading} mb-2`}
        dangerouslySetInnerHTML={{ __html: item?.title ?? '' }}
      />

      <Splide options={options} className="self-linx-splide" hasTrack={false}>
        <SplideTrack>
          {item.displays?.[0]?.recommendations?.map(
            (product: any, index: number) => (
              <SplideSlide key={product?.productId}>
                <ProductCard
                  key={product?.productId}
                  product={product}
                  index={index}
                  orientation="column"
                />
              </SplideSlide>
            )
          )}
        </SplideTrack>
      </Splide>
    </>
  )
}

export const ShelfGeneric = ShelfGenericComponent
